import { Modal, Select } from 'antd';
import * as Component from 'components';
import { contentService } from 'content/service';
import { DISTRIBUTION_OPTIONS } from '../../constants';
import React, { useState } from 'react';

const { Option } = Select;

interface ContentBulkDistributionButtonProps {
  selectedList: number[];
}

const ContentBulkDistributionButton = ({ selectedList }: ContentBulkDistributionButtonProps) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedService, setSelectedService] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const handleBulkDistribution = async (
    selectedList: number[],
    contentConsumerName: string
  ): Promise<void> => {
    if (selectedList.length === 0) {
      alert('Please select at least one content');
      return;
    }

    setLoading(true);
    try {
      await contentService.bulkDistribution(selectedList, contentConsumerName);
      setIsModalVisible(false);
      setSelectedService('');
      window.location.reload();
    } catch (error) {
      console.error('Failed to add distribution:', error);
      alert('Failed to add distribution');
    } finally {
      setLoading(false);
    }
  };

  const handleModalOk = () => {
    if (!selectedService) {
      alert('Please select a service');
      return;
    }
    handleBulkDistribution(selectedList, selectedService);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    setSelectedService('');
  };

  const showModal = () => {
    if (selectedList.length === 0) {
      alert('Please select at least one content');
      return;
    }
    setIsModalVisible(true);
  };

  return (
    <>
      <Component.CustomButtonComponent
        key="bulk-distribution"
        text="+ Add Distribution"
        onClick={showModal}
        size="small"
      />
      <Modal
        title="Add Distribution Service to Selected Content"
        open={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        confirmLoading={loading}
        okText="Add Distribution"
        cancelText="Cancel"
        width={400}
      >
        <div style={{ marginBottom: '16px' }}>
          <p style={{ marginBottom: '8px', fontWeight: '500' }}>
            Selected Content: {selectedList.length}
          </p>
          <p style={{ marginBottom: '16px', color: '#666' }}>Please select a service to distribute.</p>
        </div>

        <Select
          style={{ width: '100%' }}
          placeholder="Select a distribution service"
          value={selectedService}
          onChange={setSelectedService}
          size="large"
        >
          {DISTRIBUTION_OPTIONS.map(option => (
            <Option key={option} value={option}>
              {option}
            </Option>
          ))}
        </Select>
      </Modal>
    </>
  );
};

export default ContentBulkDistributionButton;
